import type { Geojson, Nullable } from "@/types";

export const parseGeojson = (
  value?: string
): {
  value: Nullable<Geojson>;
  error?: unknown;
} => {
  if (!value) {
    return { value: null, error: undefined };
  }

  try {
    return { value: JSON.parse(value), error: undefined };
  } catch (error) {
    return { value: null, error };
  }
};
